/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


    var buttons = document.querySelectorAll('.full-read-btn');

    buttons.forEach(function (button) {
        button.addEventListener('click', function () {
            var closestContent = findClosest(this, '.image-with-text__content');
            if (closestContent) {
                closestContent.classList.toggle('full');
            }
        });
    });

    function findClosest(element, selector) {
        while (element && !element.matches(selector)) {
            element = element.parentElement;
        }
        return element;
    }

        var pressPopupLinks = document.querySelectorAll('.press__link');
        var pressPopup = document.getElementById('popup--press');
        var pressPopupClose = null;




        pressPopupLinks.forEach(function (link) {

            link.addEventListener('click', function (e) {
                e.preventDefault();
                let text = link.dataset.text,
                    name = link.dataset.name,
                    imageUrl = link.dataset.image,
                    popupFullTextElement = pressPopup.querySelector('.popup__full_text'),
                    popupNameElement = pressPopup.querySelector('.popup__name');
                    popupImageElement = pressPopup.querySelector('.popup__image img');


                popupFullTextElement.innerHTML = text;
                popupNameElement.textContent = name;
                popupImageElement.src = imageUrl;

                pressPopup.classList.toggle('popup--visible');
            });
        });
        if(pressPopup) {
            var pressPopupClose = pressPopup.querySelector('.popup__close');

            pressPopupClose.addEventListener('click', function (e) {
                pressPopup.classList.toggle('popup--visible');
            });
        }



        // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.


})();
